import { useMutation, useQuery } from "urql";

const CHECK_PASSWORD = `
mutation CHECK_PASSWORD($input: Login!) {
  checkPassword(input: $input)
}`;

export const CheckPassword = () => {
  const [result, executeMutation] = useMutation(CHECK_PASSWORD)
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation }
}

const CHANGE_PASSWORD = `
mutation CHANGE_PASSWORD($input: ChangePasswordInput!) {
  changeUserPassword(input: $input)
}`;

export const ChangePassword = () => {
  const [result, executeMutation] = useMutation(CHANGE_PASSWORD)
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation }
}


const USER = `query GET_USER_BY_ID($id: String!) {
  User(id: $id) {
      id
      name
      email
      roles
      emails {
        address
        verified
      }
      profile {
        firstName
        lastName
        rut
        birthday
      }
      companyRole
      cashflowCollapsedCategories {
        companyId
        cashflowCategories
      }
    }
}`

export const GetUserById = variables => {
  const [result, executeQuery] = useQuery({
    query: USER,
    variables: variables,
  })
  const { data, fetching, error } = result;
  return { data, fetching, error, executeQuery }
};

const GET_PAGINATED_USERS = `
query GET_USER_BY_COMPANY($companyId: String!, $pagination: PaginationInput!, $search: String) {
    paginatedUsersByCompany(companyId: $companyId, pagination: $pagination, search: $search) {
        totalDocs
        docs {
          email
          firstName
          lastName
          companyRole
        }
      }
}`;

export const GetPaginatedUsers = variables => {
  const [result, executeQuery] = useQuery({
    query: GET_PAGINATED_USERS,
    variables: variables,
  })
  const { data, fetching, error } = result;
  return { data, fetching, error, executeQuery }
};

const DELETE_USER = `
mutation REMOVE_USER_FROM_COMPANY($userEmail: String!, $companyId: String!) {
  removeUserFromCompany(userEmail: $userEmail, companyId: $companyId) {
    id
  }
}`;

export const DeleteUser = () => {
  const [result, executeMutation] = useMutation(DELETE_USER)
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation }
}

const UPDATE_USER = `
mutation EDIT_USER_COMPANY_ROLE(
  $userEmail: String!
  $companyId: String!
  $role: String!
) {
  editUserCompanyRole(userEmail: $userEmail, companyId: $companyId, role: $role) {
    id
  }
}`;

export const UpdateUser = () => {
  const [result, executeMutation] = useMutation(UPDATE_USER)
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation }
}
const ADD_USER_TO_COMPANY = `
  mutation ADD_USER_TO_COMPANY(
    $companyId: String!
    $email: String!
    $role: String!
    $name: String
    $lastName: String
    $isPepper3: Boolean
  ) {
    addUserToCompany(
      companyId: $companyId
      email: $email
      role: $role
      name: $name
      lastName: $lastName
      isPepper3: $isPepper3
    ) {
      id
    }
  }
`

export const AddUser = () => {
  const [result, executeMutation] = useMutation(ADD_USER_TO_COMPANY)
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation }
};


const USER_HAS_COMPANIES = `
mutation USER_HAS_COMPANIES($email: String!) {
  userHasCompanies(email: $email)
}`;

export const UserHasCompanies = () => {
  const [result, executeMutation] = useMutation(USER_HAS_COMPANIES)
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation }
};

const SIGN_UP = `
mutation REGISTER($input: UserInput!) {
  signUp(input: $input) {
    id
  }
}`;

export const SignUp = () => {
  const [result, executeMutation] = useMutation(SIGN_UP)
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation }
};

const UPDATE_USER_INFO = `
mutation updateUserInfo(
  $id: String!
  $input: UserUpdateInput!
) {
  updateUser(id: $id, input: $input){
    id
    name
    email
    profile {
      firstName
      lastName
      rut
      birthday
    }
  }
}`;

export const UpdateUserInfo = () => {
  const [result, executeMutation] = useMutation(UPDATE_USER_INFO)
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation }
}

const GET_USER_ROLES = `
query GET_USER_ROLES {
  getUserRoles
}`;

export const GetUserRoles = () => {
  const [result, reExecuteQuery] = useQuery({
    query: GET_USER_ROLES,
  })
  const { data, fetching, error } = result;
  return { data, fetching, error, reExecuteQuery }
};

const UPDATE_CASHFLOW_COLLAPSED = `mutation UpdateCashflowCollapsedCategory($companyId: String! $categoryId: [String!]!){
  collapsedCashflow(companyId: $companyId, categoryId: $categoryId)
}`

export const UpdateCashflowCollapsed = () => {
  const [result, updateCashflowCollapsed] = useMutation(UPDATE_CASHFLOW_COLLAPSED)
  return updateCashflowCollapsed
}

const GET_USER_FLOW_VIEW_BY_COMPANY_ID = `query getUserFlowViewByCompanyId($companyId: String!) { 
  getUserFlowViewByCompanyId(companyId: $companyId){
    companyId
    view
    showProjections
  }
}`

export const GetUserFlowViewByCompanyId = (variables) => {
  const [result, executeQuery] = useQuery({
    query: GET_USER_FLOW_VIEW_BY_COMPANY_ID,
    variables: variables,
  })
  const { data, fetching, error } = result;
  return { data, fetching, error, executeQuery }
};

const UPDATE_USER_FLOW_VIEW_BY_COMPANY_ID = `mutation updateUserFlowViewByCompanyId($companyId: String!, $input: UserFlowPrimaryViewInput!) {
  updateUserFlowViewByCompanyId(companyId: $companyId, input: $input){
    id
  }
}`

export const UpdateUserFlowViewByCompanyId = () => {
  const [result, executeMutation] = useMutation(UPDATE_USER_FLOW_VIEW_BY_COMPANY_ID)
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation }
}
